import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { HolidayService } from '@service/holiday/holiday.service';

@Component({
  selector: 'app-clone-modal',
  templateUrl: './clone-modal.component.html',
  styleUrls: ['./clone-modal.component.css'],
})
export class CloneModalComponent implements OnInit {
  @Input() isVisible: boolean = false;
  @Input() fromYear: number;

  @Output() isVisibleChange = new EventEmitter<boolean>();
  @Output() onClone = new EventEmitter<{
    previous_year: number;
    current_year: number;
  }>();

  toYearList: any[] = [];
  selectedToYear: number | null = null;

  constructor(private holidayService: HolidayService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fromYear'] && this.fromYear) {
      console.log('From Year:', this.fromYear);
      console.log('To Year List:', this.toYearList);
      this.getYearList();
    }
  }

  ngOnInit(): void {}

  getYearList(): void {
    this.holidayService.getAllHolidayYears().subscribe((res) => {
      if (res.status === 'ok') {
        this.toYearList = res.resultset;
      }
    });
  }

  onCloneSubmit(): void {
    if (!this.selectedToYear) return;

    const payload = {
      previous_year: this.fromYear,
      current_year: this.selectedToYear,
    };

    this.holidayService.cloneYear(payload).subscribe((res) => {
      if (res.status === 'ok') {
        this.onClone.emit(payload);
        this.closeModal();
      }
    });
  }

  closeModal(): void {
    this.isVisible = false;
    this.selectedToYear = null;
    this.isVisibleChange.emit(false);
  }
}
